var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "svgexport-6 (92)",
    transform: "translate(1.906 6.998)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10683",
    d: "m3.082 2.001 8.893-4.713-.445-.815-9.734 5.068v.919l10.152 5.068.445-.815Z",
    fill: "#c1cdd3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1831",
    cx: 3.144,
    cy: 3.144,
    r: 3.144,
    transform: "rotate(-67.486 1.82 3.279)",
    fill: "#ffad39"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10684",
    d: "M5.343 1.985a3.144 3.144 0 0 1-5.85 1.6 3.144 3.144 0 0 0 5.1-2.461 3.112 3.112 0 0 0-.436-1.6 3.126 3.126 0 0 1 1.186 2.461Z",
    fill: "#e68c15"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1832",
    cx: 2.984,
    cy: 2.984,
    r: 2.984,
    transform: "rotate(-67.486 10.67 -1.85)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10685",
    d: "M15.172 7.099a2.984 2.984 0 0 1-5.553 1.517 2.983 2.983 0 0 0 4.43-3.85 2.971 2.971 0 0 1 1.123 2.333Z",
    fill: "#7859bc"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1833",
    cx: 2.984,
    cy: 2.984,
    r: 2.984,
    transform: "rotate(-67.486 2.94 -6.804)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10686",
    d: "M14.978-3.097A2.984 2.984 0 0 1 9.425-1.58a2.983 2.983 0 0 0 4.425-3.846 2.967 2.967 0 0 1 1.128 2.329Z",
    fill: "#7859bc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareColor);
export default __webpack_public_path__ + "static/media/share-color.87f0ad5d4b25f0b683f320e41d5bd338.svg";
export { ForwardRef as ReactComponent };